import featureFlags from '@enums/feature-flags';
import routeNames from '@enums/route-names';

import guardsMap from './parking-lot-guards-map';
import ParkingLotPage from './parking-lot-page.vue';
import ParkingLot from './components/parking-lot.vue';
import PastPromotions from './components/past-promotions.vue';
import SubCampaignAllocation from './components/sub-campaign-allocation.vue';

const defaultBeforeEnter = (to, from, next) => {
    guardsMap[to.name](to, from, next);
};
const routes = [
    {
        path: '/parking-lot',
        id: 'parkingLot',
        component: ParkingLotPage,
        featureToggle: 'canAccessParkingLot',
        linkText: 'navBar.parkingLot',
        index: 3,
        meta: {
            canAccess: featureFlags.canAccessParkingLot,
            isSideBarCalendarExpanded: false,
            tabTitle: 'navBar.parkingLot',
        },
        children: [
            {
                path: '',
                name: 'parking-lot',
                redirect: { name: routeNames.parkingLotPageView },
            },
            {
                path: 'parking-lot-page',
                name: routeNames.parkingLotPageView,
                beforeEnter: defaultBeforeEnter,
                component: ParkingLot,
            },
            {
                path: 'past-promotions',
                name: routeNames.pastPromotionsView,
                beforeEnter: defaultBeforeEnter,
                component: PastPromotions,
            },
            {
                path: 'sub-campaign-allocation',
                name: routeNames.subCampaignAllocationView,
                beforeEnter: defaultBeforeEnter,
                component: SubCampaignAllocation,
            },
        ],
    },
];

export default routes;
